import { KeyboardArrowDownOutlined } from "@mui/icons-material";
import { CircularProgress, MenuButton, Typography, type MenuButtonProps } from "@mui/joy";

const styles = {
    menuButton: {
        color: "white",
        fontSize: "sm",
        fontWeight: "normal",
        py: 0.5,
        px: 1,
        minHeight: "auto",
        // Reserve the same minimum footprint short org names used to get from
        // orgName's minWidth, but on the button itself: the label+chevron
        // group stays packed together on the left instead of the chevron
        // getting stranded at the button's far edge.
        minWidth: 90,
        justifyContent: "flex-start",
        "&:hover": {
            backgroundColor: "rgba(255,255,255,0.1)",
        },
    },
    orgName: {
        maxWidth: 180,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        // Buttons default to a centered text-align in the browser UA
        // stylesheet; without this, short/truncated labels inherit that
        // centering instead of sitting flush against the chevron.
        textAlign: "left",
        color: "inherit",
    },
};

/** Keep the existing compact header control for both project-routing modes. */
export default function ProjectSwitcherButton({
    label,
    title,
    color,
    disabled,
    switching,
}: {
    label: string;
    title?: string;
    color?: MenuButtonProps["color"];
    disabled?: boolean;
    switching?: boolean;
}) {
    return (
        <MenuButton
            variant="plain"
            color={color}
            title={title}
            sx={
                color
                    ? {
                          ...styles.menuButton,
                          color: "text.primary",
                          "&:hover": { bgcolor: "background.level1" },
                      }
                    : styles.menuButton
            }
            disabled={disabled}
            endDecorator={
                switching ? (
                    <CircularProgress color="neutral" sx={{ "--CircularProgress-size": "16px" }} />
                ) : (
                    <KeyboardArrowDownOutlined sx={{ fontSize: 18, color: "inherit" }} />
                )
            }
        >
            <Typography level="body-sm" sx={styles.orgName}>
                {label}
            </Typography>
        </MenuButton>
    );
}
